import { render, staticRenderFns } from "./HMSwitchTabs.vue?vue&type=template&id=34fb355c&scoped=true&"
import script from "./HMSwitchTabs.vue?vue&type=script&lang=js&"
export * from "./HMSwitchTabs.vue?vue&type=script&lang=js&"
import style0 from "./HMSwitchTabs.vue?vue&type=style&index=0&id=34fb355c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb355c",
  null
  
)

export default component.exports